export const getClientApiUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL;
  if (!apiUrl) {
    throw new Error('VITE_API_URL is not defined. Add it to your .env file.');
  }
  return apiUrl;
};

export const getAseEmail = (): string => {
  return import.meta.env.VITE_EMAIL_ASE ?? '';
};
